/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { AuditReportsGetBlueprintMetadataMetadataQueryResponse, AuditReportsGetBlueprintMetadataMetadataPathParams, AuditReportsGetBlueprintMetadataMetadataQueryParams, AuditReportsGetBlueprintMetadataMetadata400, AuditReportsGetBlueprintMetadataMetadata401, AuditReportsGetBlueprintMetadataMetadata403, AuditReportsGetBlueprintMetadataMetadata404 } from "../models/AuditReportsGetBlueprintMetadataMetadata";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { auditReportsGetBlueprintMetadataMetadata } from "../axios/auditReportsGetBlueprintMetadataMetadata";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const auditReportsGetBlueprintMetadataMetadataQueryKey = (reportType: AuditReportsGetBlueprintMetadataMetadataPathParams["reportType"], params: AuditReportsGetBlueprintMetadataMetadataQueryParams = {}) => ["api-v2", { url: '/audit-reports/v1/report-blueprints/:reportType', params: {reportType:reportType} }, ...(params ? [params] : [])] as const

export type AuditReportsGetBlueprintMetadataMetadataQueryKey = ReturnType<typeof auditReportsGetBlueprintMetadataMetadataQueryKey>

export function auditReportsGetBlueprintMetadataMetadataQueryOptions(reportType: AuditReportsGetBlueprintMetadataMetadataPathParams["reportType"], params?: AuditReportsGetBlueprintMetadataMetadataQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = auditReportsGetBlueprintMetadataMetadataQueryKey(reportType, params)
        return queryOptions<AuditReportsGetBlueprintMetadataMetadataQueryResponse, ResponseErrorConfig<AuditReportsGetBlueprintMetadataMetadata400 | AuditReportsGetBlueprintMetadataMetadata401 | AuditReportsGetBlueprintMetadataMetadata403 | AuditReportsGetBlueprintMetadataMetadata404>, AuditReportsGetBlueprintMetadataMetadataQueryResponse, typeof queryKey>({
         enabled: !!(reportType),
         queryKey,
         queryFn: async ({ signal }) => {
            return auditReportsGetBlueprintMetadataMetadata(reportType, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Retrieves blueprint metadata (sections, categories, columns) for the specified report type. If blueprintVersion is provided, uses that version; otherwise uses the latest. The response excludes internal implementation details like extraction methods.
 * @summary Get blueprint metadata
 * {@link /audit-reports/v1/report-blueprints/:reportType}
 */
export function useAuditReportsGetBlueprintMetadataMetadata<TData = AuditReportsGetBlueprintMetadataMetadataQueryResponse, TQueryData = AuditReportsGetBlueprintMetadataMetadataQueryResponse, TQueryKey extends QueryKey = AuditReportsGetBlueprintMetadataMetadataQueryKey>(reportType: AuditReportsGetBlueprintMetadataMetadataPathParams["reportType"], params?: AuditReportsGetBlueprintMetadataMetadataQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<AuditReportsGetBlueprintMetadataMetadataQueryResponse, ResponseErrorConfig<AuditReportsGetBlueprintMetadataMetadata400 | AuditReportsGetBlueprintMetadataMetadata401 | AuditReportsGetBlueprintMetadataMetadata403 | AuditReportsGetBlueprintMetadataMetadata404>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? auditReportsGetBlueprintMetadataMetadataQueryKey(reportType, params)
         

         const query = useQuery({
          ...auditReportsGetBlueprintMetadataMetadataQueryOptions(reportType, params, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<AuditReportsGetBlueprintMetadataMetadata400 | AuditReportsGetBlueprintMetadataMetadata401 | AuditReportsGetBlueprintMetadataMetadata403 | AuditReportsGetBlueprintMetadataMetadata404>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}